import { FunctionsHttpError } from '@supabase/supabase-js'

export interface FunctionsErrorBody {
  error?: string
  retryAfter?: number
}

export class FunctionsResponseError extends Error {
  readonly body: FunctionsErrorBody

  constructor(body: FunctionsErrorBody) {
    super(body.error)
    this.name = 'FunctionsResponseError'
    this.body = body
  }
}

export const handleFunctionsError = async (error: unknown): Promise<void> => {
  if (error instanceof FunctionsHttpError) {
    const body: FunctionsErrorBody = await error.context.json()

    throw new FunctionsResponseError(body)
  }

  throw new Error('There was an error')
}
